<template>
  <div>
    <van-sticky v-if="isTitle">
      <van-nav-bar :border="false">
        <template #title>
          <span :class="{ ug: language == 'ug' }">{{ $t('活动规则') }}</span>
        </template>
        <template #left>
          <img src="@/assets/icon_back.png" alt="" @click="handelBack" />
        </template>
      </van-nav-bar>
    </van-sticky>
    <div class="rule-page" :class="language">
      <div class="rule-page-title">
        <span class="icon"></span>
        <span class="title">{{ $t('活动规则') }}</span>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { CommonModule } from '@/store/modules/common'
import { appFunc_callExit } from '@/utils/bridge'

export default {
  props: {
    isTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      language: 'ug'
    }
  },
  created() {
    this.setLanguage()
  },
  methods: {
    setLanguage() {
      // 获取当前语言
      const data = this.$route.query.language || 'ug'
      this.language = data
      this.$i18n.locale = data
      CommonModule.setLanguage(data)
    },
    // 返回
    handelBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.van-nav-bar__left img {
  width: 30px;
  height: 30px;
}
.rule-page {
  padding: 16px 14px 0;
  font-size: 14px;
  color: rgba(51, 51, 51, 0.8);
  line-height: 17px;
  .rule-page-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 19px;
    .icon {
      display: inline-block;
      width: 4px;
      height: 16px;
      background: #fd4879;
      margin-right: 3px;
    }
  }
  p {
    margin-top: 8px;
  }
}
</style>
